import { useCallback, useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { Link } from 'react-router-dom'
import { useDisabledHover } from '@/hook/useDisabledHover'
import { useAccessUser } from '@/hook/useAccessUser'
import { AddProject } from '@components/project/AddProject'
import ConfirmationModal from '@components/shared/ConfirmationModal'
import FavoriteRecentProjects from '@components/project/FavoriteRecentProjects'

import './Project.css'
import ProjectsTable from '@components/project/ProjectsTable'

export const Projects = () => {
    
    const user = useWireValue(store.user)
    const projects = useWireValue(store.projects)
    
    const createNewProject = useAccessUser({
        accessType: 'projects',
        accessName: 'create_new_project',
    })
    const createProject = useDisabledHover(!createNewProject)
    
    const [searchTerm, setSearchTerm] = useState('')
    const [removeData, setProjectData] = useState({ id: '', name: '' })
    const [editProject, setEditProject] = useState()
    const [renderProjects, setRenderProjects] = useState()
    
    const [showAdd, showHideAdd] = useState(false)
    const [showDelete, showHideDelete] = useState(false)
    const [isUpdateList, setUpdateList] = useState(false)
    const [showEditProject, showHideEditProject] = useState(false)
    
    // @todo the setter is never called??
    const [isArrowAllProjects /* setHideArrowAllProjects */] = useState(false)
    
    const allProjects = useCallback(
        (projectsList = projects) => {
            const projectList = projectsList.map(project => ({ ...project, isFavorite: false }))
            
            user.favoriteProjects?.forEach(favorite => {
                projectList.forEach(project => {
                    if (favorite.id === project.id) {
                        project.isFavorite = true
                    }
                })
            })
            return projectList
        },
        [user.favoriteProjects, projects],
    )
    
    const searchValue = e => {
        setSearchTerm(e.target.value.toLowerCase())
        
        if (e.target.value === '') {
            setRenderProjects(projects)
        } else {
            if (projects && searchTerm) {
                let filtered = []
                
                for (let k of projects) {
                    if (k.name.toLowerCase().includes(searchTerm)) {
                        filtered.push(k)
                    }
                }
                
                setRenderProjects(filtered)
            }
        }
    }
    
    const handleDelete = async () => {
        const response = await Promise.all([
            actions.deleteProject(removeData.id),
            actions.deleteRecentProject({
                projectId: removeData.id,
                userId: user.id,
            }),
        ])
        
        if (response.length) {
            setUpdateList(!isUpdateList)
        }
    }
    
    const addProjectAccessId = async ({ id, userId }) => {
        await actions.createRecentProject({ projectId: id, userId })
    }
    
    const checkFavoriteProject = async (id, isAdd) => {
        let response
        const userProjectId = {
            projectId: id,
            userId: user.id,
        }
        
        if (!isAdd) {
            response = await actions.createFavoriteProject(userProjectId)
        } else {
            response = await actions.deleteFavoriteProject(userProjectId)
        }
        
        if (response) {
            setUpdateList(!isUpdateList)
        }
    }
    
    const projectEdit = project => {
        showHideEditProject(!showEditProject)
        setEditProject(project)
    }
    
    const projectDelete = (id, name) => {
        setProjectData({ id, name })
        showHideDelete(true)
    }
    
    useEffect(() => {
        actions.fetchProjects()
    }, [isUpdateList])
    
    return (
        
        <div className="Projects">
            
            <div className="row" {...createProject}>
                <button
                    className="ml-3 btn btn-primary btn-md"
                    onClick={() => {
                        showHideAdd(!showAdd)
                    }}
                    disabled={!createNewProject}>
                    Create Project
                </button>
            </div>
            
            <FavoriteRecentProjects
                projects={projects}
                user={user}
                setUpdateList={setUpdateList}
                isUpdateList={isUpdateList}
                projectEdit={projectEdit}
                projectDelete={projectDelete}
                checkFavoriteProject={checkFavoriteProject} />
            
            {/* @todo cleanup: search box */}
            <div className="mt-4 mb-1 row border-4 border-red-500">
                <div className="col-2" />
                <div className="col-7">
                    <div>
                        <div className="input-group input-group-lg input-group-merge">
                            <input
                                type="text"
                                style={{ height: '60px' }}
                                className="form-control form-control-prepended search "
                                placeholder="Search"
                                value={searchTerm}
                                onChange={e => searchValue(e)} />
                        </div>
                    </div>
                </div>
                <div className="pt-4 text-right col-3 ">
                    {isArrowAllProjects ? (
                        <i
                            className="fe fe-arrow-up icon-mid "
                            onClick={() => {
                                // @todo wtf is this
                                // eslint-disable-next-line no-restricted-globals
                                const elm = document.getElementById('scrollIdAllProjects')
                                
                                elm.scrollIntoView({ behavior: 'smooth' })
                            }} />
                    ) : (
                        <i />
                    )}
                </div>
            </div>
            
            {/* @todo cleanup: projects table/list */}
            <div className="hidden mr-2 border-4 border-lime-500" style={{ maxHeight: '605px', overflowY: 'scroll' }}>
                <div className="col-12 ">
                    <div className="ml-1 row" id="scrollIdAllProjects">
                        <div className="col-11 ">All Projects</div>
                    </div>
                    <div className="mt-2 mr-2">
                        <div className=" list-group">
                            <div
                                className="list-group-item "
                                style={{
                                    border: '3px solid #243a59',
                                    borderRadius: '8px',
                                    backgroundColor: '#152e4d',
                                }}>
                                Project Name
                            </div>
                            {allProjects &&
                                allProjects(renderProjects).map(project => !project.id ? null : (
                                    <div
                                        key={project.id}
                                        className="list-group-item "
                                        style={{
                                            minHeight: '60px',
                                            border: '3px solid #243a59',
                                            borderRadius: '8px',
                                            backgroundColor: '#152e4d',
                                        }}>
                                        <div className="row">
                                            <span
                                                className="col-6 align-self-center"
                                                onClick={() => {
                                                    addProjectAccessId({
                                                        id: project.id,
                                                        userId: user.id,
                                                    })
                                                    
                                                    // setIsFavoriteProjects(!isFavoriteProject);
                                                }}>
                                                <Link className="text-right col-6" to={`/project/${project.id}`}>
                                                    {project.name}
                                                </Link>
                                            </span>
                                            <span className="text-right col-6">
                                                <i
                                                    className={
                                                        (project.isFavorite && 'fe fe-star-fill icon-mid') ||
                                                        'fe fe-star icon-mid'
                                                    }
                                                    id={project.id}
                                                    onClick={() =>
                                                        checkFavoriteProject(project.id, project.isFavorite)
                                                    } />
                                                <i
                                                    className="pt-2 ml-3 mr-3 fe fe-edit-2 pointer-cursor"
                                                    onClick={() => projectEdit(project)} />
                                                
                                                <i
                                                    className="pt-2 fe fe-trash pointer-cursor"
                                                    onClick={() => projectDelete(project.id, project.name)} />
                                            </span>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
            
            <ProjectsTable
                projects={projects} />
            
            {showAdd && (
                <AddProject
                    showAdd={showAdd}
                    showHideAdd={showHideAdd}
                    isUpdateList={isUpdateList}
                    setUpdateList={setUpdateList} />
            )}
            
            {showEditProject && (
                <AddProject
                    showAdd={showEditProject}
                    showHideAdd={showHideEditProject}
                    editProject={editProject}
                    isUpdateList={isUpdateList}
                    setUpdateList={setUpdateList} />
            )}
            
            <ConfirmationModal
                showModal={showDelete}
                showHideModal={showHideDelete}
                title="Delete project"
                message={`Are you sure you want to delete project with name '${removeData.name}'`}
                onConfirm={() => {
                    handleDelete()
                }} />
        </div>
    )
}
